var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#docIcon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5556 9.6H10.4445C10.0167 9.6 9.66671 9.24 9.66671 8.8C9.66671 8.36 10.0167 8 10.4445 8H13.5556C13.9834 8 14.3334 8.36 14.3334 8.8C14.3334 9.24 13.9834 9.6 13.5556 9.6Z",
    fill: "#295BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5556 12H10.4445C10.0167 12 9.66671 11.64 9.66671 11.2C9.66671 10.76 10.0167 10.4 10.4445 10.4H13.5556C13.9834 10.4 14.3334 10.76 14.3334 11.2C14.3334 11.64 13.9834 12 13.5556 12Z",
    fill: "#295BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 5.2L16.6667 4L15.5 5.2L14.3333 4L13.1667 5.2L12 4L10.8333 5.2L9.66667 4L8.5 5.2L7.33333 4V15.2H5.77778C5.35 15.2 5 15.56 5 16V17.6C5 18.928 6.04222 20 7.33333 20H16.6667C17.9578 20 19 18.928 19 17.6V4L17.8333 5.2ZM14.3333 18.4H7.33333C6.90556 18.4 6.55556 18.04 6.55556 17.6V16.8H14.3333V18.4ZM17.4444 17.6C17.4444 18.04 17.0944 18.4 16.6667 18.4C16.2389 18.4 15.8889 18.04 15.8889 17.6V16C15.8889 15.56 15.5389 15.2 15.1111 15.2H8.88889V6.4H17.4444V17.6Z",
    fill: "#295BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 9.6C16.3185 9.6 16.6667 9.24183 16.6667 8.8C16.6667 8.35817 16.3185 8 15.8889 8C15.4594 8 15.1111 8.35817 15.1111 8.8C15.1111 9.24183 15.4594 9.6 15.8889 9.6Z",
    fill: "#295BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 12C16.3185 12 16.6667 11.6419 16.6667 11.2C16.6667 10.7582 16.3185 10.4 15.8889 10.4C15.4594 10.4 15.1111 10.7582 15.1111 11.2C15.1111 11.6419 15.4594 12 15.8889 12Z",
    fill: "#295BB7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "docIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.fd50320e802ac0e92690f1844a968eee.svg";
export { ForwardRef as ReactComponent };